import * as SessionStorage from "@omni/utils/sessionStorage.utils";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { useThunkDispatch } from "@/redux/dispatcher";
import { getCustomer } from "@/redux/modules/api/data/customer/customer.selectors";
import { load as getVatPrefixes } from "@/redux/modules/api/data/vatPrefixes/vatPrefixes.module";
import { broadcastMessage } from "@/redux/modules/value/messages/messages.utils";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { Config } from "@/utils/config.utils";
import { StorageKeys } from "@/utils/enums";

import ProfileDetails from "./details.component";

const ProfileDetailsContainer = () => {
    const { t } = useGranite();
    const dispatch = useThunkDispatch();
    const customer = useSelector(getCustomer);

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        const cartsMerged = SessionStorage.getItem(StorageKeys.CartsMerged);

        if (cartsMerged && cartsMerged === "true") {
            broadcastMessage({
                id: "carts-merged",
                text: `${t(
                    "account.cartsMerged.success"
                )} <a href="${Config.pages.cart}">${t(
                    "account.cartsMerged.toShoppingCart"
                )}</a>`,
                status: "success",
                dismissible: true
            });
        }
    }, []);

    useEffect(() => {
        dispatch(getVatPrefixes());
    }, [dispatch]);

    if (!customer) return null;

    return <ProfileDetails customer={customer} />;
};

export { ProfileDetailsContainer };
